export const RISK_LOW_THRESHOLD = 34
export const RISK_HIGH_THRESHOLD = 67

export function isEarlyWarningScore(row) {
  return row.earlyWarningAdj < 0 || row.riskFinal < RISK_LOW_THRESHOLD
}
